import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default function useLanguagesList() {
    const isLanguagesFormSidebarActive = ref(false);
    const languagesData = ref({});
    const toast = useToast()
    const refListTable = ref(null);
    const tableColumns = [
      
        { key: 'name', label: 'Name', sortable: false },
        { key: 'code', label: 'Code', sortable: false },
        { key: 'is_active', label: 'Active', sortable: false },
        { key: 'action', label: '#', sortable: false },


    ]
    const perPage = ref(10)
    const totals = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const statusFilter = ref(null)

    const dataMeta = computed(() => {
        const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totals.value,
        }
    })
    const refetchData = () => {
        refListTable.value.refresh()
    }
    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchData()
    })
    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);
        console.log('offset',offset);
        store
          .dispatch('app-languages/fetchData', {
            limit: perPage.value,
            offset:offset
           /* q: searchQuery.value,
            
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            status: statusFilter.value,*/
          })
          .then(response => {
           
            const  langs  = response.data.data
         
            const total = response.data.total;
            callback(langs)
            totals.value = total
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: "Error fetching Languages' list",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }
    const deleteData = (id) => {
      //fetchDeleteProperty
      store.dispatch('app-languages/deleteData',id).then(response=>{
        toast({
          component: ToastificationContent,
          props: {
            title: "Delete Success",
            icon: 'AlertTriangleIcon',
            variant: 'success',
          },
        })
        refetchData();
      }).catch(()=>{
        toast({
          component: ToastificationContent,
          props: {
            title: "Error Delete Group",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
  
      })
      //console.log('id', id);
      
    }
    const resolveStatusVariant = status => {
       
      if (status) return 'success'
      if (!status ) return 'secondary'
      return 'primary'
  }
  const resolveStatusnameVariant = status => {
      console.log('status',status);
      if (status) return 'Active'
      if (!status) return 'Inactive'
      return 'primary'
  }
  const addLanguages = (data)=>{
    console.log('addLanguages',data);
    languagesData.value = data;
    isLanguagesFormSidebarActive.value = true;
}
const updateData = (data)=>{
  
  languagesData.value = data;
    isLanguagesFormSidebarActive.value = true;
}
 
    return {
        fetchData,
        tableColumns,
        perPage,
        currentPage,
        totals,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refListTable,
    
        statusFilter,
    
   
        languagesData,
        refetchData,
        deleteData,
        resolveStatusVariant,
        resolveStatusnameVariant,
        isLanguagesFormSidebarActive,
        addLanguages,
        updateData
     }
}